export * from './src/api-infra-v1-prompt-proxy-prompts.universal.js';
